
const currentDomain = window.location.hostname;

const links = document.querySelectorAll('a');
links.forEach(link => {
  const linkHostname = new URL(link.href).hostname;
  if (linkHostname !== currentDomain) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  }
});

